import { LoadingButton } from '@mui/lab';
import { Button, Stack, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useAuthContext } from 'src/auth/hooks';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { getOrganizationDetails, getOrganizationId, putOrgDetails, resetTemplateApi } from 'src/services/user.service';
import { LoadingScreen } from 'src/components/loading-screen';
import { setLoading } from 'src/store/modalSlice';
import EmailPreviewModal from './email-preview-modal';

const EmailTemplateInterview = ({ setShowEmailPreview, emailPreviewButtonRef, open, handleClose, valid_for }) => {
    const htmlText = useRef("");
    const [copySuccess, setCopySuccess] = useState("");
    const [placeHolders, setPlaceholders] = useState([
        {
            value: "{company}",
            label: "Company Name"
        },
        {
            value: "{jobName}",
            label: "Job Name"
        },
        {
            value: "{user_name}",
            label: "Sender's Name"
        },
        {
            value: "{expiry_date}",
            label: "Valid Till"
        }
    ]);
    const [subject, setSubject] = useState("Virtual interview link for {jobName} @ {company}")
    const [reset, setReset] = useState(false);
    const [loading, setLoading] = useState(false);
    // const [showSaveTemplate, setShowSaveTemplate] = useState(false);
    const { user } = useAuthContext();
    const org_id = getOrganizationId(user);
    const [orgName, setOrgName] = useState('');
    const emailTemplateRef = useRef(null);

    const handleChange = (content, editor) => {
        htmlText.current = content;
    };
    const handleCopyClick = item => {
        navigator.clipboard.writeText(item.value).then(
            () => {
                enqueueSnackbar(`${item.label} copied to clipboard !`)
                setCopySuccess(item.value);

                setTimeout(() => {
                    setCopySuccess("");
                }, 1000);
            },
            () => {

            },
        );
    };

    const saveTemplate = async () => {
        const payload = {
            "email_template": htmlText.current,
            "subject_template": subject
        }
        // console.log(payload)
        const res = await putOrgDetails(payload, org_id);
        console.log("save template", res);
        if (res.success) {
            enqueueSnackbar("Saved successfully...");
        }
        else {
            enqueueSnackbar({ message: "Saving failed.. Please try again later...", variant: "error" })
        }
    }

    const callerFunc = async () => {
        try {
            const res = await getOrganizationDetails(org_id);
            console.log("caller", res);
            if (res.success) {
                console.log("email-template component - ", res);
                setOrgName(res.body.org_name);
                setSubject(res.body.subject_template);
                htmlText.current = res.body.email_template;
            }
        } catch (error) {
            console.log(error);
        }
    }

    const resetTemplate = async () => {
        const payload = {
            "template_type": "INTERVIEW_INVITE"
        }
        const res = await resetTemplateApi(payload, org_id);
        console.log("reset", res);
        // setSubject(res.body.subject_template);
        // setTimeout(() => {
        //     htmlText.current = res.body.email_template;
        // }, 1000);
        setReset((prev) => !prev)
        if (res.success) {
            enqueueSnackbar("Email reset successfully...");
        }
        else {
            enqueueSnackbar({ message: "Reset failed.. Please try again later...", variant: "error" })
        }
    }

    useEffect(() => {
        setLoading(true);
        callerFunc();
    }, [reset]);

    return (

        <Stack sx={{ minHeight: "50vh" }}>
            {loading && (
                <Stack
                    sx={{ zIndex: 20, height: '100%', display: 'flex', justifyContent: 'end', alignItems: "end", margin: "auto 0px" }}
                >
                    <LoadingScreen loadingText="" />
                    <Stack sx={{ visibility: "hidden", position: "absolute", zIndex: -12 }}>
                        <Editor
                            init={{
                                selector: 'textarea',
                                setup: function (editor) {
                                    editor.on('init', function () {
                                        setLoading(false);
                                        console.log('Editor is fully loaded');
                                        if (emailTemplateRef.current) emailTemplateRef.current.style.display = "block"
                                    });
                                },
                                init_instance_callback: function (editor) {
                                    var freeTiny = document.querySelector('.tox .tox-notification--in');
                                    if(freeTiny && freeTiny.style)
                                    {
                                        freeTiny.style.display = 'none';
                                    }
                                    
                                }
                            }}
                        />
                    </Stack>
                </Stack>
            )}
            <Stack ref={emailTemplateRef} sx={{ display: "none" }}>
                {!loading &&
                    <>
                        <EmailPreviewModal
                            htmlText={htmlText}
                            subject={subject}
                            orgName={orgName}
                            open={open}
                            handleClose={handleClose}
                            valid_for={valid_for}
                            emailSendBtn={false}
                            sendEmail={() => { }}
                        />
                        <Stack justifyContent="center" sx={{ width: "100%", marginBottom: "1.5rem" }} >
                            <Stack direction="row" sx={{ marginBottom: "0.8rem", }} >
                                <Typography variant="h6" sx={{ flexGrow: 1 }}>Subject</Typography>
                                <Button
                                    sx={{ border: "1px solid grey" }}
                                    variant="outlined"
                                    ref={emailPreviewButtonRef}
                                    onClick={event => {
                                        event.preventDefault();
                                        setShowEmailPreview(true);
                                    }}>
                                    Preview
                                </Button>
                            </Stack>

                            <input style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }} value={subject} onChange={(e) => setSubject(e.target.value)} type="text"></input>
                        </Stack>

                        <Stack >
                            <Typography variant="h6" sx={{ marginBottom: "0.8rem" }}>Body</Typography>
                            <Stack sx={{
                                // border: "1px solid grey",
                                // borderRadius: "5px", 
                                padding: "0.4rem",
                                display: "flex",
                                flexDirection: "row"
                            }}>
                                <Typography sx={{ fontWeight: "600", marginRight: "1rem" }}>Variables</Typography>

                                <Stack sx={{ display: "flex", flexDirection: "row", gap: "1rem", flexWrap: "wrap" }}>
                                    {placeHolders.map((item, ind) => (
                                        <Stack key={ind} sx={{ display: "flex", flexDirection: "row" }}>
                                            <Typography>{item.label}</Typography>
                                            <Button
                                                sx={{ minWidth: "30px", padding: "0px", paddingBottom: "5px" }}
                                                disabled={copySuccess === item.value}
                                                onClick={() =>
                                                    handleCopyClick(
                                                        item
                                                    )
                                                }
                                            ><Iconify icon="ph:copy" width={18} /></Button>
                                        </Stack>
                                    ))}
                                </Stack>


                            </Stack>
                            <Editor
                                apiKey={process.env.REACT_APP_TINYMCE_API}
                                // onInit={(evt, editor) => htmlText.current = editor}
                                initialValue={htmlText.current}
                                init={{
                                    height: 500,
                                    menubar: false,
                                    plugins: [
                                        'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                        'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                        'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                    ],
                                    toolbar: 'undo redo | blocks | ' +
                                        'bold italic forecolor | alignleft aligncenter ' +
                                        'alignright alignjustify | bullist numlist outdent indent | ' +
                                        'removeformat | help',
                                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                                    init_instance_callback: function (editor) {
                                        var freeTiny = document.querySelector('.tox .tox-notification--in');
                                        if(freeTiny && freeTiny.style)
                                        {
                                            freeTiny.style.display = 'none';
                                        }
                                        
                                    }
                                }}
                                onEditorChange={handleChange}
                            />
                            <Stack sx={{ display: "flex", flexDirection: "row", gap: "2rem", alignItems: "end", justifyContent: "end", marginTop: "1rem" }}>
                                <LoadingButton size="small" variant="outlined" sx={{ border: "1px solid black", width: "5rem" }} onClick={resetTemplate} loading={false}>
                                    Reset
                                </LoadingButton>
                                <LoadingButton size="small" sx={{ width: "5rem" }} onClick={saveTemplate} variant="contained" loading={false}>
                                    Save
                                </LoadingButton>
                            </Stack>
                        </Stack>
                    </>

                }
            </Stack>
        </Stack>

    )

};
export default EmailTemplateInterview;